module.exports = __webpack_public_path__ + "img/송파구 미용실.dd3facbb.png";